import { Component, Input } from '@angular/core';
import { DxPieChartModule } from 'devextreme-angular/ui/pie-chart';
import { CardAnalyticsComponent } from '../card-analytics/card-analytics.component';

@Component({
  selector: 'dk-revenue-snapshot-card',
  templateUrl: './revenue-snapshot-card.component.html',
  standalone: true,
  imports: [CardAnalyticsComponent, DxPieChartModule],
})
export class RevenueSnapshotCardComponent {
  @Input() data: any;

  customizeSaleText(arg: { percentText: string }) {
    return arg.percentText;
  }
}
